import React from 'react';
import { SectionHeader, Typography } from 'web-library';

const ConfirmParticularLabel = () => (
  <>
    <SectionHeader title="Confirm Particulars" />

    <Typography variant="body1">
      Please confirm candidate’s particulars before proceeding to the next page.
    </Typography>
  </>
);

export default ConfirmParticularLabel;
